import undefinedOrNull from './undefinedOrNull';

const filterEmptyProps = obj =>
	Object.keys(obj).reduce(
		(memo, k) => (undefinedOrNull(obj[k]) ? { ...memo } : { ...memo, [k]: obj[k] }),
		{}
	);
export default filterEmptyProps;
